import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import Slider from "react-slick";
import bannerNewImg from "../../assets/images/banner-img-new-1.webp";
// import bannerImg1 from "../../assets/images/banner-img1.jpg";
// import bannerImg2 from "../../assets/images/banner-img2.jpg";
// import bannerImg3 from "../../assets/images/banner-img-3.jpg";
// import bannerImg4 from "../../assets/images/banner-img4.jpg";
import { ROUTE_PATH } from "../../constants/route.js";
import { bannerNewStyles } from "./banner.styles.js";

const BannerNew = () => {
    const styles = bannerNewStyles;
    const naviagte = useNavigate();

    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 6000,
        cssEase: "linear",
    };

    const images = [
        // { src: bannerImg1, alt: "Banner 1" },
        // { src: bannerImg2, alt: "Banner 2" },
        // { src: bannerImg3, alt: "Banner 3" },
        // { src: bannerImg4, alt: "Banner 4" },
        { src: bannerNewImg, alt: "Banner 1" },
    ];

    return (
        <Box sx={styles.root}>
            <Box sx={styles.sliderContainer}>
                <Slider
                    infinite={false}
                    arrows={false}
                    lazyLoad={true}
                    {...settings}
                    dots={false}
                >
                    {images?.map((item, index) => (
                        <Box key={index} sx={styles.bannerWrap}>
                            <Box
                                component='img'
                                loading='lazy'
                                src={item.src}
                                alt={item.alt}
                                sx={styles.image}
                            />
                        </Box>
                    ))}
                </Slider>
            </Box>
            <Box sx={styles.overlayBox}>
                <Box sx={styles.textWrap}>
                    <Typography sx={styles.textHeader}>
                        Showcase Your Designs with Wanderobe
                    </Typography>
                    <Box sx={styles.bodywrap}>
                        <Typography sx={styles.bodyText}>
                            JoinWanderobe and unlock a new channel to connect with customers. Easy setup, guaranteed exposure, and hassle-free logistics.
                        </Typography>
                    </Box>
                    <Button
                        sx={styles.btn}
                        onClick={() => naviagte(ROUTE_PATH?.SIGNUP)}
                    >
                        Apply to be a seller
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default BannerNew;
